//  Application imports
import { IEnvironment } from 'app/models/environment';

export const environment: IEnvironment = {
    production: false,
    enableProdMode: false,
    provisioningApi: 'https://oo35plz18d.execute-api.us-east-1.amazonaws.com/playground-stage/api',
    cognitoUrl: 'https://forticloud-fsiem-playground.auth.us-east-1.amazoncognito.com',
    cognitoProvider: 'FortiCloud',
    clientId: 'ga33cbp9k9utouugbf2biin7s',
    registerUrl: 'https://support.fortinet.com/Login/CreateAccount.aspx',
    logoutUrl: 'https://support.fortinet.com/Credentials/Login/CommonLogout.aspx',
    productName: 'FortiSIEM Cloud',
    cognitoPool: 'us-east-1_RhzCh1viR',
    adminApi: 'https://oo35plz18d.execute-api.us-east-1.amazonaws.com/playground-stage/api/management',
    facCognitoUrl: 'https://fsiem-fac-playground.auth.us-east-1.amazoncognito.com',
    facCognitoProvider: 'FortinetFAC',
    facCognitoClientId: '1m6fsd0v3as5nhkskthipk4uvu',
    facCognitoLogoutUrl: 'https://fortisiem-playground.forticloud.com/logout',
    facCognitoPool: 'us-east-1_4WUbHKhXp',
};
